var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DxFullDataTable',{ref:"data_table",attrs:{"id_tabla":31,"permission_new":[],"permission_update":[],"permission_delete":[]}},[_c('template',{slot:"after_search"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }